<template>
  <div id="announcements">
    <Title title="お知らせ機能" />
    <ErrorMessage :status="announcementApiData.status" :customMessage="announcementApiData.customMessage" />

    <AnnouncementList v-show="announcementApiData.status" :announcementFields="announcementFields" :showAll="true" @update="updateAnnouncementList">
    </AnnouncementList>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Title from '@/components/Title.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'
import AnnouncementList from '@/components/AnnouncementList.vue'

import { getAnnouncementFieldsForAdmin } from '@/transformer/announcement.js'
import baseJs from '@/transformer/base'

export default {
  name: 'Announcements',
  components: {
    Title,
    ErrorMessage,
    AnnouncementList
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn
    })
  },
  data: function () {
    return {
      announcementApiData: baseJs.getApiStatusEmpty(),
      announcementFields: getAnnouncementFieldsForAdmin(true)
    }
  },
  methods: {
    updateAnnouncementList: function (message = '') {
      this.announcementApiData.status = 0
      this.$store.dispatch('Announcement/getAnnouncementList').then(result => {
        this.announcementApiData.customMessage = message
        this.announcementApiData.status = 200
      }).catch(err => {
        const apiResult = baseJs.getErrorStatus(err)
        this.announcementApiData.status = apiResult.status
        this.announcementApiData.customMessage = apiResult.customMessage
      })
    }
  },
  created: function () {
    this.updateAnnouncementList()
  }
}
</script>
